module.exports = __webpack_public_path__ + "img/pr-4.4d8989c7.png";